/*
 * VTee 並び替えカスタムドロップダウン
 * - <details data-vtee-sort-dropdown> の各 [data-vtee-sort-value] をクリック →
 *   URL の sort_by を更新して再読み込み (他のクエリパラメータは保持)
 * - 外側クリックで <details> を閉じる
 */
(function () {
  'use strict';

  function applySort(value) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function initDropdown(details) {
    if (details.dataset.vteeSortInit === '1') return;
    details.dataset.vteeSortInit = '1';

    // option 押下
    details.querySelectorAll('[data-vtee-sort-value]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        applySort(btn.dataset.vteeSortValue);
      });
    });

    // 外側クリックで閉じる
    document.addEventListener('click', function (e) {
      if (!details.contains(e.target) && details.open) {
        details.open = false;
      }
    });

    // Esc キーで閉じる
    details.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) {
        details.open = false;
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-vtee-sort-dropdown]').forEach(initDropdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
